import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | PAGE] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | PAGE] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | PAGE] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | PAGE] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | PAGE] Add Entity',
  UpdateEntity = '[STORE | ENTITY | PAGE] Update Entity',
  RemoveEntity = '[STORE | ENTITY | PAGE] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | PAGE] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | PAGE] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | PAGE] Clean Up Snapshots',
  AddVocabularyGroup = '[STORE | ENTITY | PAGE] Add Vocabulary Group',
  RemoveVocabularyGroup = '[STORE | ENTITY | PAGE] Remove Vocabulary Group',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.PageEntityModels.PageEntityType> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.PageEntityModels.PageEntityType> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.PageEntityModels.PageEntityType> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Add Vocabulary Group
 */
export class AddVocabularyGroup {
  public static readonly type = ActionTypes.AddVocabularyGroup;

  public constructor(public id: string,
                     public vocabularyGroup: FlatModels.VocabularyGroupEntityModels.VocabularyGroup) {
  }
}

/**
 * Remove Vocabulary Group
 */
export class RemoveVocabularyGroup {
  public static readonly type = ActionTypes.RemoveVocabularyGroup;

  public constructor(public id: string,
                     public vocabularyGroup: FlatModels.VocabularyGroupEntityModels.VocabularyGroup) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>